<!-- 定时管理 -->
<template>
    <div class='container containerBox'>
        <div class="handleForm" ref="handleForm">
            <el-form :inline="true" :model="handleForm" class="demo-form-inline">
                <el-form-item label="名称">
                   <el-input v-model="handleForm.timername" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                    <el-button type="primary" @click="handleAdd" icon="el-icon-plus">添加</el-button>
                </el-form-item>
            </el-form>
        </div>

        <lb-table v-loading="loading"
            :column="tableData.column"
            :data="tableData.data"
            :height="maxHeight"
            stripe
            pagination
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10, 20, 50, 100]"
            :current-page.sync="page_num"
            :total="total"
            :page-size="page_sum"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
        </lb-table>
    </div>
</template>

<script>
import LbTable from '@/components/lb-table/lb-table'
import { getMaxHeigth, $Alert } from '@/utils/utils'
import Service from '@/api/Service'

export default {
    name:  'timermana',
    data() {
        return {
            handleForm: {},
            time_kind: [],

            tableData: {
                column: [
                {
                    type: 'index',
                    align: 'center'
                },
                {
                    prop: 'Timername',
                    label: '名称'
                },
                {
                    prop: 'Enable',
                    label: '状态',
                    render: (h, scope) => {
                        if(scope.row.Enable) {
                            return (
                                <el-tag size="medium" type="success">开启</el-tag>
                            )  
                        }else {
                            return (
                                <el-tag size="medium" type="danger">关闭</el-tag>
                            ) 
                        }
                    }
                },
                {
                    prop: 'Devtype',
                    label: '控制设备',
                    render: (h, scope) => {
                        if(scope.row.Devtype === 4) {
                            return (
                                <span>PLC</span>
                            )  
                        }
                    }
                },
                {
                    prop: 'Description',
                    label: '说明'
                },
                {
                    label: '操作',
                    width: '230',
                    render: (h, scope) => {
                        return (
                            <div>
                                <el-button
                                    size="mini"
                                    onClick={ () => { this.handleControlTime(true, scope.row) } }>开启</el-button>
                                <el-button
                                    size="mini"
                                    type="danger"
                                    onClick={ () => { this.handleControlTime(false, scope.row) } }>关闭</el-button>
                                <el-dropdown type="primary" size="mini" onCommand={(val) => { this.handleMoreCommand(val, scope.row) }}>
                                    <el-button type="primary" style="margin-left:10px;" size="mini">
                                        更多<i class="el-icon-arrow-down el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item command="detele">删除</el-dropdown-item>
                                        <el-dropdown-item command="edit">编辑</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        )
                    }
                }
                ],
                data: []
            },
            loading: false,
            total: 0,
            page_num: 1,
            page_sum: 10,
            maxHeight: 500,
        };
    },

    components: { LbTable },

    computed: {},

    mounted() {
        this.$nextTick(()=>{
            this.maxHeight = getMaxHeigth();
        })
        this.onSubmit()
    },

    methods: {
        // 查询
        async onSubmit() {
            let obj = Object.assign({}, this.handleForm);
           
            let data = await Service.getTimerList(obj);
            if(data) {
                data = data === 'success' ? [] : data;
                this.tableData.data = data;
                this.total = data.length;
            }
        },
        // 新增定时
        handleAdd() {
            this.$router.push('/timerMana/addtiming/0')
        },
        handleSizeChange (val) {
            this.page_num = 1
            this.page_sum = val
        },
        handleCurrentChange (val) {
            if(isNaN(val)) return;
            this.page_num = val
        },
        // 开启当前定时器
        handleControlTime(enable, row) {
            // 开启或关闭
            let oid_array = [{oid: row.OID + ""}]
            this.setTimer(enable, oid_array)
        },
        async setTimer(enable, oid_array) {
            let data = await Service.setEnable({oid_array, enable})
            if(data) {
                this.$message({
                    type: "success",
                    message: "操作成功"
                });
                this.onSubmit()
            }
        },
        handleMoreCommand(val, row) {
            if(val === 'edit') {
                this.$router.push('/timerMana/addtiming/' + row.OID)
            }else{
                this.handleDetele(row);
            }
        },
        // 删除
        handleDetele(row) {
            $Alert(`确认删除${row.Timername}, 是否继续?`).then( async (bool)=>{
                if(bool){
                    let data = await Service.delTimer({OID: row.OID})
                    if(data) {
                        this.$message({
                            type: "success",
                            message: "删除成功"
                        });
                        this.onSubmit()
                    }
                }
            });
        },
    }
}

</script>
<style lang='less' scoped>

</style>